import { adminHttpClient } from '../../commons/adminHttpClient'

export type PerksEmployeeSignupState = {
  personalEmail?: string
  phoneNumber?: string
}

const getPerksEligibleEmployeeWizardState = (): Promise<PerksEmployeeSignupState> => {
  return adminHttpClient.get('/EESignup/Perks/Wizard/State')
}

export default getPerksEligibleEmployeeWizardState
